<template>
    <ValidationProvider
        :disabled="validationDisabled"
        v-slot="{ classes, errors }"
        :rules="rules"
        :custom-messages="customMessages"
        :class="$attrs['class']"
        class="w-full"
        :name="name"
        ref="provider"
        :vid="name"
        tag="div"
    >
        <div class="digi-fancy-select w-full" :class="classes">
            <!-- <input type="text" class="absolute opacity-0 h-0 w-0 text-transparent" tabindex="0" ref="fakeInput" inputmode="numeric" enterkeyhint="next"> -->
            <label
                class="form-label"
                :for="name"
                v-html="label"
                tabindex="0"
            ></label>
            <div class="form-input fancy-select-container">
                <div
                    class="fancy-select flex flex-wrap"
                    :class="{
                        'flex-row-reverse justify-end': type == 'toggle',
                    }"
                    :data-name="name"
                >
                    <button
                        v-for="(v, k) in options"
                        type="button"
                        class="bg-transparent option p-5px flex flex-col flex-grow-0 appearance-none border-0 outline-none content-center items-stretch relative focus:border-green-highlight"
                        :class="{
                            active: k == thisValue,
                            'w-1/3': options_per_row == 3,
                            'w-1/2': options_per_row == 2,
                            'w-1/4': options_per_row == 4,
                        }"
                        :key="k"
                        @click="handleClick(k)"
                        tabindex="-1"
                        :data-value="k"
                    >
                        <span
                            class="flex-1 inner flex bg-white p-5px flex-col border border-gray-500 border-solid justify-center text-xs leading-snug md:text-sm"
                            v-html="v"
                            v-if="type == 'normal'"
                        ></span>

                        <span
                            class="flex-1 inner flex bg-white p-5px border border-gray-500 border-solid text-sm items-center"
                            v-if="type == 'toggle'"
                        >
                            <span class="toggle-switch mx-4"></span>
                            <span v-html="v"></span>
                        </span>
                    </button>
                </div>
            </div>
            <signpost
                :signPostId="checkSignpostId"
            >
            </signpost>
            <div class="w-full" v-if="tooltip">
                <tooltip>
                    <div v-html="tooltip"></div>
                </tooltip>
            </div>
            <div
                v-if="microtext"
                class="form-microtext text-xs font-bold text-gray-700 mt-2"
                v-html="microtext"
            ></div>
        </div>
    </ValidationProvider>
</template>

<script>
import { isEmpty, isString, isNumber, isNull } from "underscore"
import { fireFullStoryFieldChangeEvent } from '../../assets/js/fullstory-helper'
import Tooltip from './tooltip'
import Signpost from './signpost'
import { isUndefined } from "underscore"
// import { isObject } from "underscore"
export default {
    components: {
    tooltip: Tooltip,
    signpost: Signpost,
},
    watch: {
        value: {
            immediate: true,
            handler(newValue, oldValue) {
                if (newValue && this.name !== 'bank_details.debit_card') {
                    window.amplitude.fancySelectEvent(this.name);
                }
                if (isNumber(newValue)) {
                    newValue = newValue.toString();
                    this.handleClick(newValue);
                    return;
                }
                if (isString(newValue) && !isEmpty(newValue)) {
                    // If this has a string value and isn't null
                    // First check to see if it's in the allowed options
                    if (isString(newValue) && this.lowerCaseOptionKeyMap[newValue.toLowerCase()] && this.lowerCaseOptionKeyMap[newValue.toLowerCase()] !== newValue) {
                        this.handleClick(this.lowerCaseOptionKeyMap[newValue.toLowerCase()]);
                    }
                }
            },
        },
    },
    data() {
        return {
            thisValue: this.value,
            showSignposting: false,
            signPostId: null,
        }
    },
    props: {
        validationDisabled: false,
        focusOnNext: {
            type: Boolean,
            default: true,
        },
        type: {
            default: 'normal',
        },
        rules: {
            default: () => {
                return {}
            },
        },
        customMessages: {
            default: () => {
                return {}
            },
        },
        options_per_row: {
            default: 3,
        },
        show: {
            default: true,
        },
        value: {
            default: null,
        },
        name: {
            default: '',
        },
        label: {
            default: '',
        },
        options: {
            default: () => {
                return {}
            },
            type: Object,
        },
        valid: {
            default: null,
        },
        microtext: {
            default: null,
        },
        tooltip: {
            default: null,
        },
        test: {
            default: false,
        }
    },
    created() {
        if (!isNull(this.value) && !isUndefined(this.value)) {
            this.$nextTick(() => {
                this.thisValue = this.value;
                if (!isNull(this.thisValue) && !isUndefined(this.thisValue)) {
                    this.$refs.provider.validate(this.thisValue);
                } else {
                    this.$refs.provider.reset();
                }
            })
        }
    },
    computed: {
        lowerCaseOptionKeyMap() {
            return Object.fromEntries(
                Object.keys(this.options).map(function (key) {
                    return [key.toLowerCase(), key];
                })
            );
        },
        checkSignpostId() {
            if (this.signPostId) {
                return this.signPostId;
            }
        }
    },
    methods: {
        updateValue(value) {
            this.thisValue = value;
            this.checkForSignposting(value);
            fireFullStoryFieldChangeEvent(this.name, value);
        },
        handleClick(value, e) {
            this.updateValue(value);
            if (this.$refs.provider) {
                this.$refs.provider.validate(value).then((result) => {
                });
            }
            this.$emit('input', this.thisValue);
            this.$emit('change', this.thisValue);
        },
        // checks whether signposting should be shown, if we want to only show for test form configs add && this.test == true
        // ensure the test parameter is set to true for the component in the form config php file
        // ensure the vue component supports the test prop, if not implement it based on the other signposting components
        // implemented by matt
        checkForSignposting(value) {
            if (value == 'debt_consolidation') {
                this.showSignposting = true;
                this.signPostId = value;
                window.amplitude.showSignposting('debt consolidation loan purpose selected.');
                return;
            }
            this.showSignposting = false;
            this.signPostId = null;
        }
    },
}
</script>
<style lang="scss" scoped>
// .digi-fancy-select {
//     border-right: 0 green solid;
//     transition: border-right-width .25s linear .75s;

//     &:focus-within {
//         border-right-width: 5px;
//         transition-delay: 0s;
//     }
// }
.p-5px {
    padding: 5px;
}
.fancy-select-container {
    margin: 0 -5px 0 -5px;
}
.fancy-select {
    .inner {
        min-height: 50px;
        border-radius: 6px;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s linear;
    }
    .toggle-switch {
        position: relative;
        height: 16px;
        width: 16px;
        border-radius: 50%;
        border: 1px solid #d6d6d6;

        &::before {
            content: '';
            position: absolute;
            display: block;
            top: 0px;
            right: 0px;
            bottom: 0px;
            left: 0px;
            border-radius: 50%;
            background-color: #3dcfaf;
            transition: transform 0.25s cubic-bezier(0.68, -0.55, 0.265, 1.55);
            transform: scale(0);
        }
    }
    .option.active {
        .inner {
            box-shadow: inset 0 0 0 1px #3dcfaf;
            border-color: #3dcfaf;
            border-width: 1px;
        }
        .toggle-switch {
            border-color: #3dcfaf;

            &::before {
                transform: scale(0.5);
            }
        }
    }
    .option {
        animation-name: clicked;
        animation-duration: 150ms;
    }
    // .option:active {
    //     z-index: 2;
    //     animation-duration: 0ms;
    // }

    // @keyframes clicked {
    //     from {
    //         transform: scale(1);
    //     }
    //     to {
    //         transform: scale(1.1);
    //     }
    // }
}
</style>
